import React, { lazy, Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "./components/ContentRoute/ContentRoute";
import { LayoutSplashScreen } from "./context/LayoutContext";
import RootLayout from "./hoc/RootLayout";
const EsyncAppts = lazy(() =>
  import("./modules/ProviderNote/EsyncAppts")
);
export default function EsyncPage({ apptID, e10xEncounter}) {
  return (
    <RootLayout>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <ContentRoute exact path="/" render={() => (
            <Redirect to={`/esync_apt/${apptID+'-'+e10xEncounter}`} />)} />
          <ContentRoute exact path="/esync_apt/:id" render={() => <EsyncAppts apptid={apptID} e10xencounter={e10xEncounter} />} />
        </Switch>
      </Suspense>
    </RootLayout>
  );
}
